<template>
  <v-container fluid v-if="!loading">
    <v-card>
      <v-card-title>Assistente de artigos</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="error" @click="goCreate">Criar</v-btn>
          </v-col>

          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Artigo</th>
                    <th class="text-left">Data</th>
                    <th class="text-left">Opções</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in articlesArray"
                    :key="item[currentLang]?.id || item?.id"
                  >
                    <td>{{ item[currentLang]?.title }}</td>
                    <td>{{ item[currentLang]?.data }}</td>
                    <td>
                      <v-btn color="success" @click="openArticle(item)">Ver</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import LoginAPI from '@/api/User.js'
import articles from '@/json_articles/articles.json'

const router = useRouter()
const { locale } = useI18n({ useScope: 'global' })

const loading = ref(true)
const articlesArray = ref([])

// idioma atual (sempre string)
const currentLang = computed(() => String(locale.value || 'pt'))

onMounted(() => {
  const auth = localStorage.getItem('auth_dreamdeal_website')
  if (auth === '0' || auth == null) {
    router.push({ name: 'backend-login', params: { lang: currentLang.value } })
    return
  }
  articlesArray.value = articles.articles || []
  loading.value = false
})

function goCreate () {
  router.push({ name: 'backend-create-article', params: { lang: currentLang.value } })
}

function openArticle (item) {
  const id = item?.[currentLang.value]?.id
  if (id == null) return
  router.push({ name: 'backend-edit-article', params: { lang: currentLang.value, article_id: id } })
}

async function logout () {
  try { await LoginAPI.logout(null) } catch {}
  localStorage.setItem('auth_dreamdeal_website', '0')
  router.push({ path: '/' })
}
</script>
